
import React, { Component } from 'react';
import { Form as FinalForm } from 'react-final-form';
import isPromise from 'is-promise';
import { submitForm } from '../../actions/form';
import { store } from '../../store';

import { FORM_ERROR } from "final-form";

class MyFinalForm extends FinalForm {
  
}

class Form extends Component {
  
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  
  async onSubmit (values) {
    const { onSubmit, onSuccess, onFail } = this.props;
    
    const fnRes = onSubmit(values)
    store.dispatch(submitForm(fnRes))
    
    const handleError = (res) => {
      if (onFail && onFail instanceof Function)
        onFail(res.errors)
      return {...res.errors, [FORM_ERROR]:res.error, [`${FORM_ERROR}-details`]: res.details}
    }
    
    try {
      const res = isPromise(fnRes) ? await fnRes : fnRes
      
      if (res && (res.errors || res.error)){
        return handleError(res)
      }
      else{
        if (onSuccess && onSuccess instanceof Function){
          onSuccess(res);
        }
        return;
      }
    }
    catch (e){
      return handleError((e.response && e.response.data) || e || 'Something went wrong.')
    }
  }
  
  render() {
    const { onSubmit, onSuccess, onFail, resetOnSuccess, ...rest } = this.props;
    
    return (
      <MyFinalForm {...rest} onSubmit={this.onSubmit} />
    )
  }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/form/Form.js